import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { addQueueGlobalCount } from '../../../store/emarsys/action';

interface Props {
  firstRef: React.RefObject<HTMLElement>;
  pageName: string;
  pageTitle: string;
  breadcrumbItems: IBreadcrumbs[];
  carModel: string;
  sectionName: string;
}

const useImpressionDetailTestDrive = ({
  firstRef,
  pageTitle,
  pageName,
  breadcrumbItems,
  carModel,
  sectionName,
}: Props) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    (callbackFunction) => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      if (isAuth && isFlagActive && sectionName) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: pageName ?? '',
          page_title: pageTitle ?? '',
          page_url: window.location.href,
          menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toUpperCase() ?? '',
          menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase() ?? '',
          car_model: carModel ?? '',
          section_name: sectionName ?? '',
        };

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueGlobalCount());
        callbackFunction();
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0,
    true
  );

  return null;
};

export default useImpressionDetailTestDrive;
